import NavHeader from "./navheader.js";
import TopHeader from "./topheader.js";
import Footer from './footer.js';

export default function Company() {
    return (
        <div>
            <NavHeader mode="Company" navBrand="Your Team" />
            <TopHeader MenuLevel="Company" />
            <Footer />
        </div>
    )
}